import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance16obx3u7ddx5e as Data_getInstance } from './adapter/SpinMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SpinMutation_VariablesAdapter_instance2vqhdncm9464h as SpinMutation_VariablesAdapter_instance } from './adapter/SpinMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(spin) {
        this.b6h_1 = spin;
      }
      toString() {
        return 'Data(spin=' + this.b6h_1 + ')';
      }
      hashCode() {
        return this.b6h_1 == null ? 0 : getBooleanHashCode(this.b6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.b6h_1 == other.b6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.c6h_1 = '9e9620cf6c68a6bcc9b17a91bc9bb717ac303825fa49b83e7b6138072b6a4df3';
        this.d6h_1 = 'spin';
      }
      j6e() {
        return 'mutation spin($input: SpinInput!) { spin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SpinMutationClass;
function SpinMutation() {
  if (SpinMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.e6h_1 = input;
      }
      l6e() {
        return '9e9620cf6c68a6bcc9b17a91bc9bb717ac303825fa49b83e7b6138072b6a4df3';
      }
      operationId() {
        return this.l6e();
      }
      z47() {
        return Companion_instance.j6e();
      }
      m6e() {
        return 'spin';
      }
      operationName() {
        return this.m6e();
      }
      t46(writer, customScalarAdapters, withDefaultValues) {
        SpinMutation_VariablesAdapter_instance.f6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      s46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SpinMutation(input=' + this.e6h_1.toString() + ')';
      }
      hashCode() {
        return this.e6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpinMutation()))
          return false;
        if (!this.e6h_1.equals(other.e6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpinMutation', VOID, VOID, [Mutation()]);
    SpinMutationClass = $;
  }
  return SpinMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data17skrs4gatjls,
  SpinMutation as SpinMutation3rsfya4nf2aew,
};
//endregion

//# sourceMappingURL=SpinMutation.mjs.map
